import { Box, Image } from '@chakra-ui/react'
import { LANGUAGES } from 'commons/constants/language'
import { useTranslation } from 'react-i18next'

const assetsBaseUrl = `${process.env.REACT_APP_PAYMENT_FORM_URL}l/assets/img/payment-form`

export const HeroIllustration = () => {
	const { i18n } = useTranslation()
	const assetName =
		i18n.language === LANGUAGES.FRENCH ? 'qrcode_claim_FR.png' : 'qrcode_claim_EN.png'

	return (
		<Box
			position='relative'
			w='full'
			h={{ base: '311px', sm: '371px' }}
			mx='auto'
			display='flex'
			justifyContent='center'
		>
			<Box
				w='100%'
				h={{ base: '311px', sm: '371px' }}
				borderRadius='29.814px'
				border='11px solid #0178F0'
				background='linear-gradient(180deg, #0178F0 0%, #013B8B 100%)'
				boxShadow='0 0 0 1px rgba(255, 255, 255, 0.12), 0 0 68.802px 11.467px rgba(1, 128, 255, 0.13)'
				zIndex={0}
				pointerEvents='none'
			/>
			<Image
				src={`${assetsBaseUrl}/${assetName}`}
				alt=''
				w={{ base: '300px', sm: '360px' }}
				h='auto'
				position='absolute'
				top='0px'
			/>
		</Box>
	)
}
